module.exports = __webpack_public_path__ + "static/media/Ship-Meraviglia-horizon-pool.73d851d7.webp";